import TemplateRouter from './TemplateRouter';

export default TemplateRouter;
